import { v4 as uuid } from "uuid"

export const DOCUMENT_ENTITY = "document"

export interface Document {
  id: string
  date: Date
  type: "duerp" | "papripact"
  url: string | null
  content: any
  EstablishmentId: string
}

type DocumentGenerationDiffType = "added" | "updated" | "removed"
type DocumentGenerationDiffScope = "physicalRisk" | "populationRps"

export interface DocumentGenerationDiff {
  id: string
  type: DocumentGenerationDiffType
  scope: DocumentGenerationDiffScope
  label: string
}

/**
 * Crée un Document vide, avec possibilité de surcharger les valeurs.
 */
export const createEmptyDocument = (overrides?: Partial<Document>): Document => {
  const base: Document = {
    id: uuid(),
    date: new Date(),
    type: "duerp",
    url: null,
    content: [],
    EstablishmentId: ""
  }

  return { ...base, ...overrides }
}
